import React, { useEffect, useState } from 'react'
import './onlineuser.css'

const OnlineUser = ({id}) => {

      const [online, setOnline] = useState([])

      async function getOnline(id_xat){
            const url = `https://oceanbot.net/online.php?id=${id_xat}`
            try{
                  const response = await fetch(url)
                  const result = await response.json()
                  setOnline(result)
            }
            catch(err){
                  console.log(err)
            }
      }

      id = id.replace('M', '000000')

      useEffect(() => {
            getOnline(id)
      }, [id])

      return (
            <div className="online_user flex">
                  <div className={online.status === "online" ? "dots green" : "dots red"}></div>
                  <span>{online.status === "online" ? "Online Now" : "Offline"}</span>
            </div>
      )
}

export default OnlineUser
